import { cloneDeep, orderBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { roundOff, shortenStringWithTooltip } from '../../../Components/helper';
import { usePlanningBottomupState } from '../Context/index';
import useTerminalCalculationHooks from '../Hooks/useTerminalCalculationHooks';

export function ChannelTable() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { calculateTerminal } = useTerminalCalculationHooks();
  const { planningBottomProducts, selectedLevel } = planningBottomup;
  const reducer = useSelector((estate) => estate);
  const { PlanningBottomReducer } = reducer;
  const { ActiveChannels } = PlanningBottomReducer;
  const [state, setState] = useState({
    channelList: [],
  });
  const { channelList } = state;
  const level = selectedLevel?.level;
  useEffect(() => {
    if (ActiveChannels) {
      const sorted = orderBy(ActiveChannels, ['position'], ['asc']);
      setState((prev) => ({ ...prev, channelList: sorted }));
    }
  }, [ActiveChannels]);

  const handleChange = async (value, item, type, refKey, index) => {
    const copyState = cloneDeep(planningBottomProducts);
    let txt1 = Number(value);
    if (type === 'ratio') {
      const newVal = Math.round((Number(txt1) * item?.fpSalesUnits) / 100);
      item[refKey].unit.value = newVal;
      item[refKey].unit.ratio = value;
    } else {
      if (type === 'unit') {
        txt1 = Math.round(value);
        let newVal = 0;
        if (item?.fpSalesUnits > 0) {
          newVal = roundOff((Number(txt1) / item?.fpSalesUnits) * 100, 2);
        }
        item[refKey].unit.ratio = newVal;
      }

      item[refKey][type].value = value;
    }
    copyState[index] = await calculateTerminal(item, level);
    setPlanningBottomup((prev) => ({
      ...prev,
      planningBottomProducts: copyState,
    }));
  };

  const getDisabled = (value) => {
    if (level > 6) {
      return !!(value && value > 0);
    }
    return false;
  };

  const tableHeadRows = (buyDependent, channelItem) => {
    return (
      <tr>
        {buyDependent && channelItem?.unit?.type === 'manual' && (
          <th className="w-200px">{shortenStringWithTooltip(channelItem?.channelName, 13)} Ratio of Sales</th>
        )}
        <th className="w-200px">
          <span>Unit {shortenStringWithTooltip(channelItem?.channelName, 15)}</span>
        </th>
        <th className="w-200px">
          <span> Cost {shortenStringWithTooltip(channelItem?.channelName, 15)}</span>
        </th>
      </tr>
    );
  };
  const ratioOfSalesBody = (buyDependent, channelItem, trItem, iParent, refKey) => {
    return (
      buyDependent &&
      channelItem?.unit?.type === 'manual' && (
        <td className="text-right">
          {channelItem?.unit?.type === 'manual' && level >= 6 ? (
            <input
              disabled={level !== 6}
              value={trItem[refKey]?.unit?.ratio}
              onChange={(e) => handleChange(e.target.value, trItem, 'ratio', refKey, iParent)}
              className="form-control "
            />
          ) : (
            trItem[refKey]?.unit?.ratio || 0
          )}
        </td>
      )
    );
  };
  return channelList?.map((channelItem, i) => {
    const buyDependent = channelItem?.channelType === 'buyDependent';
    const refKey = channelItem?.refKey;
    const isVisible = checkVisibleBottomUp(channelItem?.refKey);
    return (
      isVisible && (
        <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3" key={i}>
          <thead>{tableHeadRows(buyDependent, channelItem)}</thead>
          <tbody>
            {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
              return (
                <tr key={iParent}>
                  {ratioOfSalesBody(buyDependent, channelItem, trItem, iParent, refKey)}
                  <td className="text-right">
                    {channelItem?.unit?.type === 'manual' && level >= 6 ? (
                      <input
                        value={trItem[refKey]?.unit?.value}
                        onChange={(e) => handleChange(e.target.value, trItem, 'unit', refKey, iParent)}
                        className="form-control "
                      />
                    ) : (
                      Math.round(trItem[refKey]?.unit?.value || 0)
                    )}
                  </td>
                  <td className="text-right">
                    {channelItem?.cost?.type === 'manual' && level >= 6 ? (
                      <input
                        value={trItem[refKey]?.cost?.value}
                        disabled={getDisabled(trItem[refKey]?.cost?.totalCost)}
                        onChange={(e) => handleChange(e.target.value, trItem, 'cost', refKey, iParent)}
                        className="form-control "
                      />
                    ) : (
                      roundOff(trItem[refKey]?.cost?.value || 0, 2)
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )
    );
  });
}
export default ChannelTable;
